export enum MainMenuAccessEntities {
  DASHBOARD = 'dashboard',
  CUSTOM_ROLE = 'custom-role',
  USER = 'user',
  USER_LOG = 'user-log',
  USER_BILLING_REPORT = 'user-billing-report',
  PROJECT = 'project',
  PROJECT_COUNTRY = 'project-country',
  REGION = 'region',
  ACQUIRER = 'acquirer',
  INSURANCE_PROVIDER = 'insurance-provider',
  SMS_GATEWAY = 'sms-gateway',
  PAYMENT_SERVICE = 'payment-service',
  SUPPORT_CONTACT = 'support-contact',
  ACCEPTANCE_CERTIFICATE = 'acceptance-certificate',
  DOCUMENT = 'document',
  LEGAL_DOCUMENT = 'legal-document',
  LEGAL_ENTITY = 'legal-entity',
  BRANCH_OFFICE = 'branch-office',
  BUSINESS_LOGIC = 'business-logic',
  PROJECT_END_USER_LEVEL = 'project-end-user-level',
  ENTITY_PROJECT_END_USER_LEVEL_CONFIG = 'project-end-user-level-config',
  REPEATER = 'repeater',
  UNIT_MODEL = 'unit-model',
  UNIT_TYPE = 'unit-type',
  COMPONENT_TYPE = 'component-type',
  COMPONENT_MODEL = 'component-model',
  COMPONENT = 'component',
  COMPONENT_WITHOUT_SN = 'component-without-sn',
  WAREHOUSE = 'warehouse',
  UNIT = 'unit',
  UNIT_GROUP = 'unit-group',
  BATTERY = 'battery',
  BATTERY_REPLACEMENT_ACCOUNTING = 'battery-replacement-accounting',
  GEOFENCE = 'geofence',
  GEOPOINT = 'geopoint',
  GEO_OBJECTS = 'geoobjects',
  GEOPOINT_TYPE = 'geopoint-type',
  END_USER_PRICE_PLAN = 'end-user-price-plan',
  EXECUTOR_PRICE_PLAN = 'executor-price-plan',
  PREPAID_SHARING_PRICE_PLAN = 'prepaid-sharing-price-plan',
  EXECUTOR_PRICE_PLAN_GROUP = 'executor-price-plan-group',
  BALANCE_PACKAGE = 'balance-package',
  SUBSCRIPTION = 'subscription',
  COMMODITY = 'commodity',
  TOURIST_ROUTE = 'tourist-route',
  NOTIFICATION = 'notification',
  END_USER_NOTIFICATION = 'end-user-notification',
  UNIT_LOG = 'unit-log',
  END_USER_LOG = 'end-user-log',
  SERVICE_REQUEST = 'service-request',
  END_USER = 'end-user',
  END_USER_GROUP = 'end-user-group',
  FINANCIAL_OPERATION = 'financial-operation',
  END_USER_SUSPICIOUS = 'end-user-suspicious',
  BAG = 'bag',
  WORK_SHIFT = 'employee-shift',
  EXECUTOR = 'executor',
  EMPLOYEE = 'employee',
  EXECUTOR_BILLING_LONG_TERM = 'executor-billing-long-term',
  EMPLOYEE_GROUP = 'employee-group',
  USER_EMPLOYEE_EXTENDED_REGISTRATION_FORM = 'user-employee-extended-registration-form',
  END_USER_ORDER = 'end-user-order',
  END_USER_ORDER_GALLERY = 'end-user-order-gallery',
  PREPAID_SHARING_ORDER = 'prepaid-sharing-order',
  BALANCE_PACKAGE_PURCHASE = 'balance-package-purchase',
  TOURIST_ROUTE_PURCHASE = 'tourist-route-purchase',
  END_USER_SUBSCRIPTION = 'end-user-subscription',
  COMMODITY_PURCHASE = 'commodity-purchase',
  PROMO_CODE = 'promo-code',
  END_USER_PROMO_CODE = 'end-user-promo-code',
  DIAGNOSTICS = 'diagnostics',
  REPORT = 'report',
  STATISTIC = 'statistic',
  PROMOTION_AND_NEWS = 'promotions-and-news',
  ORDER_STATISTIC = 'order-statistic',
  DEMAND = 'demand',
  ORDER_SEARCH = 'order-search',
  PAID_MESSAGE_LOG = 'paid-message-log',
  UNIT_HW_MODEL = 'unit-hw-model',
  UNIT_COMMAND_TEXT = 'unit-command-text',
  UNIT_COMMAND_DESCRIPTION_PER_ADMIN = 'unit-command-description-per-admin',
  WEEKLY_SCHEDULE = 'weekly-schedule',
}

export type MainMenuAccessEntity = typeof MainMenuAccessEntities[keyof typeof MainMenuAccessEntities];
